var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowBack = function SvgArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M0 20.022V0h22v20.024z",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M4.583 10.845h10.872l-3.328 3.638c-.324.355-.27.881.12 1.176.39.295.968.247 1.292-.108l4.583-5.006a.99.99 0 0 0 .083-.125c0-.042 0-.067.064-.108a.77.77 0 0 0 .064-.3.769.769 0 0 0-.064-.301c0-.042 0-.067-.064-.109a.984.984 0 0 0-.083-.125L13.54 4.472a.955.955 0 0 0-.706-.3.974.974 0 0 0-.587.191.815.815 0 0 0-.327.566c-.023.22.052.44.208.61l3.328 3.638H4.583c-.506 0-.917.373-.917.834 0 .461.41.835.917.835Z"
  })));
};
export { SvgArrowBack as ReactComponent };
export default __webpack_public_path__ + "1a3dafe26867bb5d90988d8fb4edb6d5.svg";